import React, {useState} from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import {useDummyDataLoader} from '../hooks/useDummyDataLoader';
import {useReviewContext} from '../contexts/ReviewContext';

interface LoadAllDummyDataButtonProps {
  readOnly: boolean;
  incrementRefreshKey: () => void;
  onCompleted?: () => void;
}

export const LoadAllDummyDataButton: React.FC<LoadAllDummyDataButtonProps> = ({
  readOnly,
  incrementRefreshKey,
  onCompleted,
}) => {
  const {reviewDetails} = useReviewContext();
  const {loadAllDummyData, isLoading} = useDummyDataLoader({
    readOnly,
    incrementRefreshKey,
    onCompleted,
  });

  const [open, setOpen] = useState(false);
  const [reviewName, setReviewName] = useState('');

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    if (!reviewName.trim()) return;
    setOpen(false);

    await loadAllDummyData(reviewName);
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        disabled={readOnly || isLoading}
        variant="contained"
        size="small"
      >
        {isLoading ? 'Loading...' : 'Load All Dummy Data'}
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Enter Review Name</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Review Name"
            fullWidth
            value={reviewName}
            onChange={(e) => setReviewName(e.target.value)}
            data-testid="type-review-name"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleConfirm}
            disabled={!reviewName.trim()}
            variant="contained"
            data-testid="confirm-review-name"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
